/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { useState } from 'react';
import cn from 'classnames';

import { TextInput, ITextInputProps } from 'UIPackage/MainModule/components/TextInput';

import styles from './TextInputEditableLinkField.module.scss';
import { EditButton } from './EditButton';
import { Button } from './Button';

type Value = ITextInputProps['value'];
type ITextInputEditableLinkFieldProps = ITextInputProps &
  FieldProps<Value, FieldRenderProps<Value>> & {
    isEditable?: boolean;
  };

export const TextInputEditableLinkField = (props: ITextInputEditableLinkFieldProps) => {
  const {
    afterSubmit,
    allowNull,
    beforeSubmit,
    data,
    defaultValue,
    format,
    formatOnBlur,
    initialValue,
    isEqual,
    multiple,
    name,
    parse,
    subscription,
    type,
    validate,
    validateFields,
    value,
    disabled,
    ...componentProps
  } = props;

  return (
    <Field
      afterSubmit={afterSubmit}
      allowNull={allowNull}
      beforeSubmit={beforeSubmit}
      data={data}
      defaultValue={defaultValue}
      format={format}
      formatOnBlur={formatOnBlur}
      initialValue={initialValue}
      isEqual={isEqual}
      multiple={multiple}
      name={name}
      parse={parse}
      subscription={subscription}
      type={type}
      validate={validate}
      validateFields={validateFields}
      value={value}
    >
      {({ input, meta }) => {
        const inputValue = input.value;
        const clearedValue = inputValue && typeof inputValue === 'string' ? inputValue.trim() : undefined;

        const [isEdit, setIsEdit] = useState(disabled ? false : !(clearedValue && clearedValue.length > 0));
        const [prevLinkValue, setPrevLinkValue] = useState(clearedValue);

        const { ...restComponentProps } = componentProps;

        const error =
          (meta.touched && restComponentProps.error) || (meta.touched && meta.error) ? meta.error : undefined;
        const errorOnSubmit = meta.error && (meta.dirty || meta.submitFailed) && meta.touched && meta.error;

        const resultError = restComponentProps.validateOnSubmit ? errorOnSubmit : error;

        return (
          <div className={styles.Wrapper}>
            {isEdit ? (
              <TextInput {...restComponentProps} {...input} disabled={disabled} error={resultError} />
            ) : (
              <div className={styles.LinkWrapper}>
                <a
                  className={cn('shared-table-link', styles.Link)}
                  href={clearedValue ? encodeURI(clearedValue) : ''}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {clearedValue}
                </a>
              </div>
            )}

            {!disabled && (
              <>
                {isEdit ? (
                  <Button
                    className={styles.SaveButton}
                    text="Сохранить"
                    color="default"
                    size="medium"
                    type="button"
                    id="saveButton"
                    disabled={resultError || disabled || !(clearedValue && clearedValue.length > 0)}
                    onClick={() => {
                      setPrevLinkValue(clearedValue);
                      input.onChange(clearedValue);
                      setIsEdit(false);
                    }}
                  />
                ) : (
                  <EditButton className={styles.EditIconButton} onClick={() => setIsEdit(true)} />
                )}
                {isEdit && prevLinkValue && (
                  <Button
                    className={styles.CancelButton}
                    variant="link"
                    color="primary"
                    text="Отмена"
                    size="medium"
                    type="button"
                    disabled={clearedValue === prevLinkValue || !prevLinkValue || disabled}
                    onClick={() => {
                      if (clearedValue !== prevLinkValue) {
                        input.onChange(prevLinkValue);
                        setIsEdit(false);
                      }
                    }}
                  />
                )}
              </>
            )}
          </div>
        );
      }}
    </Field>
  );
};
